import React from 'react';
import {connect} from 'react-redux';
import {
    closeValuePropositionPopup,
    updateEditValuePropositionSection,
    openPagePicker,
    closePagePicker,
} from '../../actions';
import {
    pickValuePropositionPage,
    updateTitleFieldInTheSectionEditPopup,
    updateValuePropositionButtonText,
    updateValuePropositionTitle,
    updateValuePropositionBody,
    updateImageInValuePropositionPopup,
    updateThumbCroppedImageInValuePropositionPopup,
    deleteImageInValuePropositionPopup,
    updateImageMetaInValuePropositionPopup,
    updateCroppedImageInValuePropositionPopup,
} from '../../sections/actions';

import ValuePropositionSectionEditPopup from './value_proposition_section_edit';
import {onSearchPages} from '../../../page-picker/thunks';
import {clearPageSearchFilter} from '../../../page-picker/actions';
import {fetchImageRatios} from '../../../images/thunks';
import {showErrMsgPopup} from '../../../../components/helpers/helpers';

class ValuePropositionPopup extends React.Component {
    componentWillUpdate(nextProps) {
        if (
            nextProps.valuePropositionSectionEditOpen === true &&
            this.props.valuePropositionSectionEditOpen === false
        ) {
            this.props.fetchImageRatios();
        }
    }

    render() {
        return (
            <ValuePropositionSectionEditPopup
                open={this.props.valuePropositionSectionEditOpen}
                siteId={this.props.siteId}
                pageId={this.props.pageId}
                sectionId={this.props.valuePropositionSectionId}
                title={this.props.valuePropositionSectionTitle}
                valuePropositions={
                    this.props.valuePropositionSectionValuePropositions
                }
                sectionPagePickerPopupOpen={
                    this.props.sectionPagePickerPopupOpen
                }
                pageSearchCriteria={this.props.pageSearchCriteria}
                allPagesBySearchCriteria={this.props.allPagesBySearchCriteria}
                onSearchPages={this.props.onSearchPages}
                onPickSectionPage={this.props.onPickSectionPage}
                openPagePicker={() => this.props.openPagePicker()}
                closePagePicker={() => {
                    this.props.closePagePicker();
                    this.props.clearPageSearchFilter();
                }}
                onUpdateTitleField={(title) =>
                    this.props.updateValuePropositionSectionTitleField(title)
                }
                updateValuePropositionButtonText={
                    this.props.updateValuePropositionButtonText
                }
                updateValuePropositionTitle={
                    this.props.updateValuePropositionTitle
                }
                updateValuePropositionBody={
                    this.props.updateValuePropositionBody
                }
                imageRatios={this.props.imageRatios.value_proposition}
                onUpdateImageField={(index, images) =>
                    this.props.updateImageSectionFields(index, images[0])
                }
                onDeleteImageField={(image, index) =>
                    this.props.deleteImageFromSectionField(image, index)
                }
                onCropImage={(index, image, imageUrlBlob, imageBlobObject) => {
                    this.props.updateCroppedImage(
                        index,
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onCropThumbImage={(
                    index,
                    image,
                    imageUrlBlob,
                    imageBlobObject
                ) => {
                    this.props.updateThumbCroppedImage(
                        index,
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onImageMetaUpdate={(index, imageMeta) => {
                    this.props.updateImageMeta(index, imageMeta);
                }}
                onHandleSubmit={() => {
                    // Add crop alert on DONE for the value proposition image
                    let imageHasCrop = this.props.sectionData.value_propositions.find(
                        (proposition) =>
                            proposition.image &&
                            proposition.image.new &&
                            !proposition.image.deleted &&
                            proposition.image.croppedImage === null
                    );
                    imageHasCrop
                        ? showErrMsgPopup(
                              'Cropping the Value Proposition Image is mandatory! Please click on it in order to CROP it.'
                          )
                        : this.props.updateValuePropositionSectionContents(
                              this.props.pageId,
                              this.props.valuePropositionSectionId,
                              this.props.sectionData
                          );
                }}
                onHandleClose={() =>
                    this.props.closeValuePropositionSectionPopup()
                }
            />
        );
    }
}

const mapStateToProps = (state, props) => ({
    sectionData: state.pageBuilderSectionPopup.data,
    valuePropositionSectionEditOpen:
        state.pageBuilder.valuePropositionSectionPopup.open,
    valuePropositionSectionId: state.pageBuilderSectionPopup.sectionId,
    valuePropositionSectionTitle: state.pageBuilderSectionPopup.data.title,
    valuePropositionSectionValuePropositions:
        state.pageBuilderSectionPopup.data.value_propositions,
    sectionPagePickerPopupOpen:
        state.pageBuilder.sectionPagePickerPopup.open,
    clearPageSearchFilter: clearPageSearchFilter,
    pageSearchCriteria: state.pagePicker.pageSearchCriteria,
    allPagesBySearchCriteria: state.pagePicker.allPagesBySearchCriteria,
    siteId: state.pageBuilder.pages[props.pageId].meta.site_id,
    imageRatios: state.images.ratios,
});

export default connect(
    mapStateToProps,
    {
        closeValuePropositionSectionPopup: closeValuePropositionPopup,
        updateValuePropositionSectionTitleField: updateTitleFieldInTheSectionEditPopup,
        updateValuePropositionSectionContents: updateEditValuePropositionSection,
        openPagePicker: openPagePicker,
        closePagePicker: closePagePicker,
        onSearchPages: onSearchPages,
        onPickSectionPage: pickValuePropositionPage,
        updateValuePropositionButtonText: updateValuePropositionButtonText,
        updateValuePropositionTitle,
        updateValuePropositionBody,
        fetchImageRatios,
        updateImageSectionFields: updateImageInValuePropositionPopup,
        deleteImageFromSectionField: deleteImageInValuePropositionPopup,
        updateCroppedImage: updateCroppedImageInValuePropositionPopup,
        updateThumbCroppedImage: updateThumbCroppedImageInValuePropositionPopup,
        updateImageMeta: updateImageMetaInValuePropositionPopup,
    }
)(ValuePropositionPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/value_proposition_popup.js